import { render } from "./house-23.vue?vue&type=template&id=06237f86&scoped=true"
import script from "./house-23.vue?vue&type=script&lang=js"
export * from "./house-23.vue?vue&type=script&lang=js"

import "./house-23.vue?vue&type=style&index=0&id=06237f86&lang=scss&scoped=true"

import exportComponent from "/Users/dima/Projects/OrangeStatic/rise-homestories/public/themes/rise-theme/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-06237f86"]])

export default __exports__